import React from 'react';
import Lottie from 'lottie-react';

import Grid from '@material-ui/core/Grid';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import useStore from '@hooks/useStore';
import useStyles from '@components/AccountsPayableCustomTable/styles';

import processing from '@assets/lotties/processing.json';
import { formattedAmount } from '@utils/format';

interface EnhancedTableToolbarProps {
  numSelected: number;
  rowCount: number;
  totalAmount: number;
  group?: string;
  canSelect: boolean;
  toolBarTitle: string;
  isInProcess: boolean;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const { accountsPayableLink } = useStore();
  const { fundInfo } = accountsPayableLink;
  const { numSelected, rowCount, totalAmount, group, canSelect, toolBarTitle, isInProcess } = props;
  const classes = useStyles({});

  const title = !group ? toolBarTitle : group;

  return (
    <Grid container className={classes.resumeContainer}>
      <AccordionSummary
        className={
          group ? classes.accordionGroupedSummaryContainer : classes.accordionSummaryContainer
        }
        expandIcon={group ? <ExpandMoreIcon /> : null}
        aria-controls={!group ? 'panel1a-content' : `panelc-${group}`}
        id={!group ? 'panel1a-header' : `panelh-${group}`}
      >
        <Grid item xs={6}>
          <span className={classes.titleStep}>
            {isInProcess && (
              <Lottie style={{ width: 20, marginRight: 5 }} animationData={processing} />
            )}{' '}
            {title}{' '}
            <span className={classes.rowsCounter} style={{ marginLeft: 10 }}>
              {canSelect ? `${numSelected} de ${rowCount}` : rowCount}
            </span>
          </span>
        </Grid>
        <Grid item xs={6} className={classes.totalLeftAmountContainer}>
          <span className={classes.totalAmount}>
            {formattedAmount(totalAmount, fundInfo.currency)}{' '}
            <span className={classes.totalAmountCurrency}>{fundInfo.currency}</span>
          </span>
        </Grid>
      </AccordionSummary>
    </Grid>
  );
};

export default EnhancedTableToolbar;
